export const ShowAlert = ({ errors, alerts = {}, tag = "", type = "danger" }) => {
    alerts = errors ? errors : alerts;
    if (tag.length && alerts && alerts[tag]) {
        return <div role="alert" className={`alert alert-${alerts[tag].type ?? type}`} ><span>{alerts[tag].message ?? alerts[tag]}</span></div>
    }
    if (!tag.length && alerts) {
        return Object.keys(alerts).map((v, k) => <ShowAlert key={k} alerts={alerts} tag={v} type={type} />)
    }
    return
}